import { ApiError, Box, Table, Text } from "@shared/primitive-components"
import { useLDFlags } from "@shared/integration/launchdarkly"
import { buildHrefLinkForRows } from "@shared/utils/helpers/buildHrefLinkForRows"
import { useMemo } from "react"
import { useSearchTripVehicles } from "../../../api/insights"
import { PATHS } from "../../../const/paths"
import { usePolicyAndFleet } from "../../../contexts"
import { SummaryCardMainText } from "../../components"
import { InsightsVehicleData, makeVehicleData } from "../../handlers"
import { scoreStyles as styles } from "../../styles"
import { generateWorstScoringVehiclesTableColumns } from "./tableColums"

export const WorstScoringVehiclesTable = () => {
  const { policy } = usePolicyAndFleet()
  const ldFlags = useLDFlags()
  const { useNewTripViews } = ldFlags
  const baseUrl = `${PATHS.INSIGHTS.BASE}/${PATHS.INSIGHTS.VEHICLES}`
  const columns = useMemo(() => generateWorstScoringVehiclesTableColumns(), [])
  const [resVehicles] = useSearchTripVehicles({
    limit: 5,
    minimumDistanceDriven: 16,
    policyId: policy.id as string,
    sortKey: `currentPeriod.driverRanking`,
    sortOrder: `DESC`,
  })

  if (resVehicles.result?.tag === `err`) return <ApiError />

  const fiveWorstScoreVehicles =
    resVehicles.loading || !resVehicles.result?.data ? [] : makeVehicleData(resVehicles.result.data.items)

  const TooltipContent = (
    <Text css={styles.tooltip}>
      <span>
        These vehicles are ranked based on their negative impact to your overall fleet safety score.
        <br />
        <br />
        The ranking considers both the vehicle&apos;s individual safety score and the total miles driven.
        <br />
        <br />A vehicle with a lower safety score that has driven more miles may rank lower than a vehicle with a
        slightly higher score but fewer miles driven.
      </span>
    </Text>
  )

  return (
    <Box css={styles.worstScoringVehiclesContainer}>
      <SummaryCardMainText
        main="Worst scoring vehicles"
        tooltip={TooltipContent}
        expand={{
          label: `View all`,
          path: baseUrl,
        }}
        hasData={fiveWorstScoreVehicles.length > 0}
      />
      <Table<InsightsVehicleData>
        loading={resVehicles.loading}
        data={fiveWorstScoreVehicles}
        columns={columns}
        renderRowAsAnchor
        buildUrl={(row) =>
          buildHrefLinkForRows(
            `${PATHS.INSIGHTS.BASE}/${PATHS.INSIGHTS.VEHICLES}`,
            useNewTripViews ? `${row.cells[0].value.vrn}/trips` : row.cells[0].value.vrn
          )
        }
      />
    </Box>
  )
}

WorstScoringVehiclesTable.defaultProps = {
  loading: undefined,
}
